import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'quote',
    labelKey: 'chatbot.suggestions.quote',
    messageKey: 'chatbot.suggestions.quoteMessage',
  },
  {
    id: 'certifications',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 * Clicking copies the value to clipboard.
 */
export const contactCTAs: ContactCTA[] = [
  {
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 030 7460669',
  },
  {
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@chemicalnewtech.com',
  },
]
